import { Pipe, PipeTransform } from '@angular/core';

import { Loan, MpmLoan } from '@shared/enums/loan-type.enum';
/*
 * Convert opportunity type to svg icons.
 * Usage:
 *   loan | loanName
 * @example
 * // returns loan name
 * {{ 'Home' | loanName }}
 */
@Pipe({
  name: 'loanName'
})
export class LoanNamePipe implements PipeTransform {
  transform(loan: Loan | MpmLoan): string {
    return `${loan} loan`;
  }
}
